import { http } from 'src/boot/axios'
import API from 'src/api'

export default {
  URL: API.GRAPHQL_URL + 'task-hierarchy',

  getSites(params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/sites`, { params, ...config })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(err)
        })
    })
  },

  storeSite(data) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}/sites`, data)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  updateSite(id, data) {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}/sites/${id}`, data)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  deleteSite(id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}/sites/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  getSubcategories(params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/subcategories`, { params, ...config })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(err)
        })
    })
  },

  storeSubcategory(data) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}/subcategories`, data)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  updateSubcategory(id, data) {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}/subcategories/${id}`, data)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  deleteSubcategory(id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}/subcategories/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  getRelations(params = {}) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/relations`, { params })
        .then(res => resolve(res.data))
        .catch(err => {
          reject(err)
        })
    })
  },

  toggleRelation(data) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}/relations`, data)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  deleteRelation(id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}/relations/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  getCategoriesForSite(siteId, config = {}) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/sites/${siteId}/categories`, config)
        .then(res => resolve(res.data))
        .catch(err => {
          reject(err)
        })
    })
  }
}

